<template>
    <div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <h4 class="card-title pl-3 pb-2 mb-0">Total Akses Dashboard iOffice Plus</h4>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/> 
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="line" height="300" v-if="status == true" :options="options" :series="series"></apexchart>
            <!-- <apexchart type="donut" height="330" v-if="status == true" :options="chartOptions" :series="series"></apexchart> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ['keterangan', 'transaksi'],
    data() {
        return {
            status: false,
            options: {
                stroke: {
                    curve: 'straight',
                },
                chart: {
                    id: 'vuechart-example'
                },
                xaxis: {
                    categories: []
                },
                zoom: {
                    enabled: false
                }
            },
            series: []
        }
    },
    watch: {
        keterangan() {
            this.status = false
            this.getData()
        },
        transaksi() {
            this.status = false
            this.getData()
        },
    },
    methods: {
        getData() {
            this.options =  {
                stroke: {
                    curve: 'straight',
                },
                chart: {
                    id: 'vuechart-example'
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            let value = val.toString()
                            let leng = value.length
                            let sisa 	= leng % 3
                            let rupiah 	= value.substr(0, sisa)
                            let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                
                            if (ribuan) {
                                let separator = sisa ? '.' : ''
                                rupiah += separator + ribuan.join('.')
                            }
                            return rupiah
                        }
                    },
                },
                xaxis: {
                    categories: this.keterangan
                },
                zoom: {
                    enabled: false
                }
            }
            this.series = []
            var j = 0
            let intt = []
            for(j=0;j<this.transaksi.length;j++) {
                intt.push(parseInt(this.transaksi[j]))
            }
            let onPush = {
                name: 'Total Transaksi',
                data: intt
            }
            this.series.push(onPush)
            this.status = true
        }
    },
    mounted() {
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
</style>